import config from '../../../app/config'
import AxiosInstance from '../../axios/AxiosInstance'

export const getOrgsWithFeatures = (features) => {
  return AxiosInstance.post(
    `${config().LOCATION_SERVICE_BASE}/organization/withFeatures`,
    features,
  )
}
